import { useEffect, useRef, useState } from "react";

/**
 * Keeps list state in sync with Apollo query `data` on every update — including
 * pollInterval ticks and scroll-pagination refetches.
 *
 * Do not use onCompleted + setList for polled lists; Apollo only calls
 * onCompleted on the first completion.
 *
 * Retains the previous list while a refetch is in flight (e.g. when limit
 * increases on scroll) so rows do not flash empty.
 */
export default function useApolloListData(data, getList) {
  const [list, setList] = useState([]);
  const getListRef = useRef(getList);
  getListRef.current = getList;

  useEffect(() => {
    if (!data) return;
    setList(getListRef.current(data) ?? []);
  }, [data]);

  return list;
}
